import { Component } from 'react'
import PropTypes from 'prop-types'

class SsoCodeManager extends Component {
    constructor(props) {
        super(props)

        // Expose command to the dev console
        window.ssoCode = this.setSsoCode
    }

    shouldComponentUpdate() {
        return false
    }

    setSsoCode = (ssoCode, force = false) => {
        if (this.props.ssoCodeFallbackEnabled && !force) {
            console.info('Login with SSO code is currently in fallback mode')
            return
        }

        console.info('UI received ssoCode from backend...')

        this.props.ltsLogin(ssoCode).then((user) => {
            if (user.isError) {
                console.info(`Error on LTS Login: ${user.error}`)

                // Display error message
                this.props.displayError()
                return
            }

            this.props.loginUser(user)
        })
    }

    render() {
        return null
    }
}

SsoCodeManager.propTypes = {
    ltsLogin: PropTypes.func,
    ssoCodeFallbackEnabled: PropTypes.bool,
    displayError: PropTypes.func,
    loginUser: PropTypes.func,
}

export default SsoCodeManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/SsoCodeManager/component.js